import { useMemo, useState } from "react";
import ArticleCard from "@/components/feature/ArticleCard";
import HotRankingList from "@/components/feature/HotRankingList";
import type { Article } from "@/types/content";
import { articles as allArticles } from "@/mocks/articles";

interface CategoryFeedProps {
  articles: Article[];
}

type SortKey = "hot" | "new";

export default function CategoryFeed({ articles }: CategoryFeedProps) {
  const [sortBy, setSortBy] = useState<SortKey>("hot");

  const sorted = useMemo(
    () =>
      [...articles].sort((a, b) =>
        sortBy === "hot" ? b.hot - a.hot : b.views - a.views
      ),
    [articles, sortBy]
  );

  return (
    <section className="w-full px-4 md:px-8 py-10 md:py-14 bg-background-50">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-8">
        <div className="lg:col-span-2">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-5">
            <h2 className="text-lg md:text-xl font-bold text-foreground-950">
              本瓜田全部爆料
            </h2>
            <div className="inline-flex items-center gap-1 p-1 rounded-full bg-background-100 border border-background-200 w-fit">
              {(
                [
                  { key: "hot", label: "最热" },
                  { key: "new", label: "最新" },
                ] as { key: SortKey; label: string }[]
              ).map((option) => (
                <button
                  key={option.key}
                  type="button"
                  onClick={() => setSortBy(option.key)}
                  className={`px-4 py-1.5 rounded-full text-sm whitespace-nowrap cursor-pointer transition-colors ${
                    sortBy === option.key
                      ? "bg-background-50 text-primary-600 font-medium"
                      : "text-foreground-600 hover:text-foreground-900"
                  }`}
                >
                  {option.label}
                </button>
              ))}
            </div>
          </div>

          {sorted.length > 0 ? (
            <div className="flex flex-col gap-3 md:gap-4">
              {sorted.map((article) => (
                <ArticleCard key={article.id} article={article} variant="row" />
              ))}
            </div>
          ) : (
            <div className="rounded-lg border border-dashed border-background-300 bg-background-50 py-16 text-center">
              <p className="text-sm text-foreground-500">
                这个瓜田还在等第一颗瓜，稍后再来看看。
              </p>
            </div>
          )}
        </div>

        <div className="flex flex-col gap-5">
          <HotRankingList articles={allArticles} limit={6} title="全站热榜" />
          <div className="rounded-lg bg-accent-100 border border-accent-200 p-5">
            <span className="w-10 h-10 rounded-md bg-accent-500 text-foreground-950 flex items-center justify-center mb-3">
              <i className="ri-lightbulb-flash-line text-xl" aria-hidden="true"></i>
            </span>
            <h3 className="text-base font-bold text-accent-950">吃瓜小提示</h3>
            <p className="mt-2 text-sm text-accent-950/75 leading-relaxed">
              爆料类内容存在不确定性，围观时建议把多方说法和时间线放在一起看，
              重要判断请以官方回应为准。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}